module.exports = __webpack_public_path__ + "static/media/hall-icon.ce9c867f.png";